"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
const getSoldDays_1 = __importDefault(require("../../utils/fleetquote/getSoldDays"));
const getSoldHours_1 = __importDefault(require("../../utils/fleetquote/getSoldHours"));
/**
 * Returns formatted booking price info
 * @param {FleetPriceType} bookingPrice
 * @returns {FleetPriceDetailsPriceType}
 */
function bookingPriceFactory(bookingPrice, soldDays, currency) {
    const hasDiscount = !!Number((0, get_1.default)(bookingPrice, 'discount', ''));
    const hasDropOffSum = !!Number((0, get_1.default)(bookingPrice, 'dropOffSum', ''));
    const hasPromoCode = !!(0, get_1.default)(bookingPrice, 'promoCode', '');
    const formatedSoldDays = (0, getSoldDays_1.default)(`${soldDays}`);
    const dailyKmsAllowance = (0, get_1.default)(bookingPrice, 'dailyKmsAllowance', 0);
    return {
        cdw: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'cdw'), currency),
        totalPrice: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'totalPrice'), currency),
        currency,
        soldDays: formatedSoldDays,
        soldHours: (0, getSoldHours_1.default)(`${soldDays}`) || 0,
        vat: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'vat'), currency),
        vatPercentage: `${Number((0, get_1.default)(bookingPrice, 'vatPercentage')).toFixed(0)}%`,
        rental: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'rentalSum'), currency),
        extra: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'extraSum'), currency),
        discount: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'discount'), currency),
        hasDiscount,
        hasPromoCode,
        dropOffSum: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'dropOffSum'), currency),
        hasDropOffSum,
        dropOffCharge: (0, formatPriceValue_1.default)((0, get_1.default)(bookingPrice, 'dropOffCharge'), currency),
        dailyKmsAllowance,
        extraKmsCharge: (0, get_1.default)(bookingPrice, 'extraKmsCharge', 0),
        allowanceKms: Math.trunc(dailyKmsAllowance * Number(formatedSoldDays)),
    };
}
exports.default = bookingPriceFactory;
